import { Component, OnInit } from '@angular/core';
import { RegistrationService } from '../../../services/registration.service';

@Component({
  selector: 'app-packing',
  templateUrl: './packing.component.html',
  styleUrls: ['./packing.component.scss'],
  standalone: false
})
export class PackingComponent implements OnInit{
  active = 1;
  attendee;
  attendeeWaveNo;

  constructor(
    private registrationService: RegistrationService
    ) {

    this.attendee = this.registrationService.getAttendee({});
    this.attendeeWaveNo = this.registrationService.getAttendee({}).WaveNo;
    //console.log(this.attendeeWaveNo == 1);

     }

  ngOnInit(): void {
  }
}
